<div class="item-grid-container">
    <div class="carrier-promotions-form">
         <form
           [formGroup]="bannerPromoForm"
           (ngSubmit)="onBannerFormSubmit($event)"
         >
           <div class="form-inner buss-info-details content-details-blk">
             <div class="row">
               <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                 <div class="row">
                   <div
                     class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                   >
                     <h4 class="form-item-label mb-0" translate>
                       {{'pages.PromotionCarrierPromotions.PromotionName' | translate }}<span class="required">*</span>
                     </h4>
                   </div>
                   <div
                     class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                   >
                     <div class="form-item-input">
                       <mat-form-field appearance="outline" class="w-100">
                         <input
                           matInput
                           type="text"
                           maxlength="70"
                           formControlName="promotionName"
                           placeholder="{{'pages.PromotionCarrierPromotions.PromotionName' | translate }}"
                         />
                       </mat-form-field>
                     </div>
                   </div>
                 </div>
                 <div class="row">
                   <div
                     class="
                       col-lg-3 col-md-3 col-sm-3 col-xs-12
                       align-self-start
                       mt-2
                     "
                   >
                     <h4 class="form-item-label mb-0" translate>
                       {{'pages.placeholders.PromotionDescription' | translate }}<span class="required">*</span>
                     </h4>
                   </div>
                   <div
                     class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                   >
                     <div class="form-item-input textarea">
                       <mat-form-field appearance="outline" class="w-100">
                         <textarea
                           matInput
                           type="text"
                           formControlName="promitionDescription"
                           placeholder="{{'pages.placeholders.PromotionDescription' | translate }}"
                         ></textarea>
                       </mat-form-field>
                     </div>
                   </div>
                 </div>
                 <div class="row">
                   <div
                     class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center"
                   >
                     <h4 class="form-item-label mb-0" translate>
                      Upload Image<span class="required">*</span>
                     </h4>
                   </div>
                   <div
                     class="col-lg-9 col-md-9 col-sm-9 col-xs-12 align-self-center"
                   >
                     <div class="form-item-input">
                       <div class="profile-img-blk" >
                         <img src="{{ profilePicPath }}"  class="img-fluid "
                         alt="profile_img"/>
                         <i class="mi mi-add-a-photo add-photo">
                         <input type="file" accept=".jpg, .jpeg, .png" class="upload-container"
                         id="file" formControlName="imagePreview"
                         (change)="handleFileInput($event.target.files)"> </i>
                         <!-- <p class="text-center profile-pic-name">{{selectedImageName}}</p> -->
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
   
             <div class="row validityRow">
               <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                 <h4 class="form-item-label mb-0" translate>{{'pages.Promocodehistory.Validity' | translate }}</h4>
               </div>
   
               <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                 <div class="row">
                   <div class="col-12 col-xs-12 col-sm-6">
                     <div class="form-item-input">
                       <mat-form-field appearance="outline" class="w-100">
                         <input
                           matInput
                           [matDatepicker]="picker"
                           formControlName="promocodeStartDate"
                           placeholder="{{'pages.Creditlinereport.From' | translate }}"
                         />
                         <!-- <span matPrefix>{{'pages.Creditlinereport.From' | translate }}</span> -->
                         <mat-datepicker-toggle matSuffix [for]="picker">
                           <mat-icon matDatepickerToggleIcon
                             >keyboard_arrow_down</mat-icon
                           >
                         </mat-datepicker-toggle>
                         <mat-datepicker #picker></mat-datepicker>
                       </mat-form-field>
                     </div>
                   </div>
                   <div class="col-12 col-xs-12 col-sm-6">
                     <div class="form-item-input">
                       <mat-form-field appearance="outline" class="w-100">
                         <input
                           matInput
                           [matDatepicker]="picker1"
                           formControlName="promocodeEndDate"
                           [min]="
                             bannerPromoForm.controls['promocodeStartDate'].value
                           "
                           placeholder="{{'pages.Creditlinereport.To' | translate }}"
                         />
                         <mat-datepicker-toggle matSuffix [for]="picker1">
                           <mat-icon matDatepickerToggleIcon
                             >keyboard_arrow_down</mat-icon
                           >
                         </mat-datepicker-toggle>
                         <mat-datepicker #picker1></mat-datepicker>
                       </mat-form-field>
                     </div>
                   </div>
                 </div>
               </div>
   
              
   
             
             </div>
            
           
             <div class="row">
               <div class="row">
                 <div class="col-12">
                   <mat-checkbox
                     color="primary"
                     formControlName="displayBanner"
                     (change)="onCheckCertify($event)"
                     class="is-certified"
                     >Display Promotion</mat-checkbox
                   >
                 </div>
               </div>
             </div>
             <div class="form-footer text-center">
               <button
                 mat-raised-button
                 color="primary"
                 [disabled]="checkSubmitDisplayed()"
                 type="submit"
               >
                 Save Banner
               </button>
               <button
                 mat-stroked-button
                 color="primary"
                 type="button"
                 
                 (click)="onCancel()"
               >
                 <span translate class="translate">pages.newRetailer.cancel</span>
               </button>
             </div>
           </div>
         </form>
       </div>
   </div>
   